import anime, { AnimeParams } from "animejs";
import { getEl } from "../helpers";

/**
* Start the loader animation
*/
export default class Loader {
    animationDuration = 600;
    animation: anime.AnimeInstance;

    constructor() {
        let el = getEl('#report-loader .loader-image-wrap');

        if (!el) return;

        this.animation = anime({
            targets: el,
            duration: this.animationDuration*2,
            easing: 'easeInOutSine',
            opacity: [0.5, 1],
            direction: 'alternate',
            loop: true
        });
    }

    finishAndRemove() {
        let el = getEl('#report-loader');

        const scrollY = window.scrollY;

        const animParams: AnimeParams = {
            targets: el,
            duration: this.animationDuration,
            easing: 'easeInOutSine',

            complete: () => {
                el.remove();
                el = null;
                this.animation = null;
            }
        };

        if (scrollY <= window.innerHeight*0.5)
        {
            animParams.opacity = 0;
        }
        else
        {
            animParams.translateY = '-100vh';
        }

        this.animation.loop = false; //Stop the pulsing logo animation.
        anime(animParams);
    }
}
